export default "__VITE_ASSET__Bv9hl$jF__"